<template>
<div class="block">
    <el-carousel  :arrow="alarmContent.length>1?'always':'never'" :interval="3000" :indicator-position="alarmContent.length>1?'':'none'">
        <el-carousel-item  v-for='(item,index) in alarmContent' :key='index'>
            <div class="box">
                <div class="head_style_button">
                      <!-- <el-button
                        type="danger"
                        circle 
                        icon="el-icon-s-tools"
                        @click="table = true"
                        ></el-button> -->
                         <el-button-group class="ml-4">
                            <el-button type="danger" size="small" title="隐藏提示框于左上角" icon="el-icon-minus" @click="showDeatil(item,index,0)" />
                            <el-button type="danger" size="small" title="查看更多数据" icon="el-icon-s-data"  @click="showDeatil(item,index,1)"/>
                            <el-button type="danger" size="small" title="解除本次报警" icon="el-icon-close-notification" @click="showDeatil(item,index,2)"/>
                            <el-button type="danger" size="small" title="查看报警位置" icon="el-icon-s-flag" @click="showDeatil(item,index,3)"/>

                        </el-button-group>
                </div>
                <div class='box_title'>
                    <img  class='img_icon title' src="https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/icon/alarm_icon.png"/>
                    <span class='title'>{{item.levelName}}</span>
                    
                </div>
                <div class='box_content'>
                    <div class="content-item">
                        <img src='../../../../static/img/icon/device_name.png'/>
                        <span class='content'>{{item.deviceName}}</span>
                    </div>
                    <div class="content-item">
                        <img src='https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/icon/address.png'/>
                        <span class='content'>{{item.devicePosition}}</span>
                    </div>
                    <div class="content-item">
                        <img src='../../../../static/img/icon/time.png'/>
                        <span class='content'>{{item.time}}</span>
                    </div>
                </div>
                <div>
                    <div @click.stop='deal_alarm(item,index)' class='alarm'>接警</div>
                </div>
                </div>
        </el-carousel-item>
    </el-carousel>
</div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'
export default {
     props: {
        alarmContent: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data(){
        return{
            // data:{
            //     address:'北京市丰台区木材厂院内',
            //     people:'北燃四分运营公司',
            //     phone:'010-678900000'
            // },
            box_data:[],
        }
    },
  filters: {
    formatDate: function (value) {
      console.log(value,'传过来的数据')
      var date = new Date(value * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    }
  },

    mounted(){
        this.box_data = this.alarmContent;


        console.log(this.alarmContent,'传过来的数据')


    },
    computed:{
      ...mapState(['onMessageArrived']),
    },
    watch:{
        alarmContent(newVal,oldVal){
            console.log(newVal,'弹出框的报警内容');
            if(Array.isArray(newVal)){
              this.box_data = newVal;
            }
        }
    },
    methods: {
      deal_alarm(item, index) {
        this.$emit('deal', item, index);
      },
      showDeatil(item, index, exeindex) {
        this.$emit('showDeatil', item, index, exeindex)
      },
         formatDate: function (value) {
           console.log('formatDate-=-=-=-=-='+JSON.stringify(value))

           let date = new Date(value);
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? ('0' + MM) : MM;
          let d = date.getDate();
          d = d < 10 ? ('0' + d) : d;
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        }
     }
}
</script>
<style lang="less" scoped>
.box{
    width: 100%;
    height: 100%;
    // background: url(../../../../static/img/alarm_bg.png) no-repeat;
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/alarm_bg.png) no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 9;
      .head_style_button{
            position: absolute;
            right: 0px;
            top: 25px;
            right: 10px;
        }
    .box_title{
        // background: #e60004;
        
        height:84px;
        line-height: 84px;
        color: #ffc600;
        text-align: left;
      
        .title{
            width: 58px;
            height: 48px;
            vertical-align:middle;
            margin-left: 10px;
            font-size: 30px;

        }
        .img_icon{
            margin-left: 53px;
        }
    }
    .box_content{
        width:470px;
        text-align: left;
        margin-left: 80px;
        margin-top: 23px;
        
        .content-item{
            display: flex;
            align-items: center;
            height: 35px;
            width: 100%;
            
        }
        .content{
            height:27px;
            line-height: 27px;
            font-size: 16px;
            color: #ffffff;
            margin-left: 18px;
        }
    }
    .alarm{
        width: 133px;
        height: 43px;
        margin: 0 auto;
        margin-top: 24px;
        line-height: 40px;
        border:3px solid #620b1c;
        background: #dc0a15;
        font-size: 26px;
        text-align:center;
        color: #ffffff;
        cursor: pointer;
    }
    
}
</style>
<style lang='less'>
.alarm_box {
    .el-carousel .el-carousel__container{
        height: 300px !important;
    }
    .el-carousel__item{
        display:block !important;
    }
}
</style>





// WEBPACK FOOTER //
// src/page/main_content/alarm/alarm_box.vue